import { PublicRoutes } from "@/constants/routes";

export const SITE_URL = "https://fidexa.com.br";

export type ToolKey =
  | "gerador_carne"
  | "simulador_crediario"
  | "calculadora_inadimplencia";

export type ToolSummary = {
  key: ToolKey;
  path: string;
  /** Nome curto: menu, cartão do hub, breadcrumb. */
  name: string;
  summary: string;
  /** Rótulo do botão que abre a ferramenta: verbo + objeto. */
  cta: string;
};

/** Catálogo único: hub, menu do header e "outras ferramentas" leem daqui. */
export const TOOLS: ToolSummary[] = [
  {
    key: "gerador_carne",
    path: PublicRoutes.FERRAMENTA_GERADOR_CARNE,
    name: "Gerador de carnê",
    summary:
      "Monte o carnê de crediário da venda e imprima ou salve em PDF, sem cadastro.",
    cta: "Gerar carnê",
  },
  {
    key: "simulador_crediario",
    path: PublicRoutes.FERRAMENTA_SIMULADOR_CREDIARIO,
    name: "Simulador de crediário",
    summary:
      "Calcule parcela, juros, CET e a tabela mês a mês, e mande a simulação ao cliente no WhatsApp.",
    cta: "Simular crediário",
  },
  {
    key: "calculadora_inadimplencia",
    path: PublicRoutes.FERRAMENTA_CALCULADORA_INADIMPLENCIA,
    name: "Calculadora de inadimplência",
    summary:
      "Descubra quanto dinheiro sua loja deixa na rua por ano com parcelas em atraso.",
    cta: "Calcular inadimplência",
  },
];

/** Texto do (i) do CET: o mesmo no campo de tarifa e no resultado. */
export const CET_EXPLANATION =
  "Custo efetivo total: tudo o que o cliente paga pelo crediário, juros mais tarifas como a de cadastro, em uma taxa só. Sem tarifa, é igual à taxa de juros.";

export type BlogLink = { title: string; path: string };

export const BLOG_POSTS = {
  jurosCrediario: {
    title: "Como calcular juros do crediário próprio em rede de lojas",
    path: "/blog/como-calcular-juros-crediario-proprio",
  },
  reguaAutomatica: {
    title:
      "Régua de cobrança automática no crediário: guia para redes de lojas",
    path: "/blog/regua-cobranca-automatica-crediario-rede-lojas",
  },
  negativar: {
    title: "Como negativar cliente devedor do crediário próprio",
    path: "/blog/negativar-cliente-devedor-crediario-proprio",
  },
  vazamentoInvisivel: {
    title:
      "O vazamento invisível do varejo: onde o dinheiro realmente se perde",
    path: "/blog/o-vazamento-invisivel-do-varejo-onde-o-dinheiro-realmente-se-perde",
  },
  cobrarIgual: {
    title:
      "A inadimplência não é o maior problema. O maior problema é cobrar do mesmo jeito que há 10 anos.",
    path: "/blog/a-inadimplencia-nao-e-o-maior-problema-o-maior-problema-e-cobrar-do-mesmo-jeito-que-ha-10-anos",
  },
} satisfies Record<string, BlogLink>;

export type Crumb = { name: string; path: string };

export const HUB_CRUMB: Crumb = {
  name: "Ferramentas",
  path: PublicRoutes.FERRAMENTAS,
};

export const breadcrumbSchema = (trail: Crumb[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ name: "Início", path: "/" }, ...trail].map(
    (crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: crumb.path === "/" ? `${SITE_URL}/` : `${SITE_URL}${crumb.path}`,
    })
  ),
});

export const webApplicationSchema = ({
  name,
  path,
  description,
}: {
  name: string;
  path: string;
  description: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name,
  url: `${SITE_URL}${path}`,
  description,
  applicationCategory: "FinanceApplication",
  operatingSystem: "Web",
  inLanguage: "pt-BR",
  isAccessibleForFree: true,
  offers: { "@type": "Offer", price: "0", priceCurrency: "BRL" },
  publisher: { "@type": "Organization", name: "Fidexa", url: SITE_URL },
});
